import {BrowserRouter, Route, Router, Routes} from "react-router-dom";
import CallBack from "./CallBack";
import UserPortal from "./Userprotal";
import HomePage from "./HomePage";

function App() {
  return (
      <BrowserRouter basename="/fayda/v2">
        <Routes>
            <Route path="/callback" element={<CallBack />} />
            <Route path="/acctVerf" element={<UserPortal />} />
            <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
  );
}

export default App;
